export default "__VITE_PUBLIC_ASSET__eb88020d__"